import Picture from 'components/Picture';
import {getMediaSrc} from 'core/helpers/media';
import {useAppSelector} from 'core/redux/hooks/useAppSelector';
import {getProductBrandUrl, makeBrandLogoSources} from 'modules/product-card/helpers';
import {selectProductData} from 'modules/product-card/selectors';
import {FC} from 'react';
import style from './style.module.scss';
import Link from 'components/CustomRoutingLink';

export const BrandLogo: FC = () => {
    const productData = useAppSelector(selectProductData);
    const {brand} = productData || {};
    const brandImage = brand?.logo?.url ?? '';

    if (!brand?.logo?.url) {
        return null;
    }

    return (
        <div className={style.main}>
            <Link href={getProductBrandUrl(brand?.code)}>
                <Picture sources={makeBrandLogoSources(brandImage)} src={getMediaSrc(brandImage)} />
            </Link>
        </div>
    );
};
